import React, { useMemo } from 'react';
import DoodMascot from './DoodMascot';
import ScribbleButton from './ScribbleButton';

// Hand-drawn speech bubble SVG
function SpeechBubble() {
  return (
    <div className="speech-bubble-wrapper">
      <svg viewBox="0 0 320 110" className="speech-bubble-svg">
        {/* Wobbly bubble shape */}
        <path
          d="M 15,10
             Q 8,5 20,5
             L 280,8
             Q 310,5 308,20
             L 312,75
             Q 315,92 295,88
             L 100,90
             L 70,108
             L 80,85
             L 25,88
             Q 5,90 8,70
             L 5,25
             Q 3,12 15,10
             Z"
          fill="#f5f3ee"
          stroke="#1a1a1a"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <text
          x="160"
          y="38"
          textAnchor="middle"
          fontFamily="'Permanent Marker', cursive"
          fontSize="22"
          fill="#1a1a1a"
        >
          JUST BUY THIS
        </text>
        <text
          x="160"
          y="68"
          textAnchor="middle"
          fontFamily="'Permanent Marker', cursive"
          fontSize="26"
          fill="#1a1a1a"
        >
          COIN MF
        </text>
      </svg>
    </div>
  );
}

// Hand-drawn arrow SVG
function ScribbleArrow({ style, className }) {
  const wobble = useMemo(() => Math.random() * 20 - 10, []);
  return (
    <svg
      viewBox="0 0 80 120"
      className={`scribble-arrow ${className || ''}`}
      style={{ width: 60, height: 90, ...style }}
    >
      <path
        d={`M 40,5 Q ${35 + wobble},40 ${42 + wobble / 2},80 L 30,70 M ${42 + wobble / 2},80 L 52,68`}
        fill="none"
        stroke="#1a1a1a"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function HeroSection({ onScribbleToggle, isScribbling }) {
  return (
    <section className="hero-section">
      {/* Scattered decorative scribbles */}
      <svg className="hero-scribble hero-scribble-1" viewBox="0 0 60 60" width="50" height="50">
        <circle cx="30" cy="30" r="20" fill="none" stroke="#1a1a1a" strokeWidth="2" strokeDasharray="6 4" />
      </svg>
      <svg className="hero-scribble hero-scribble-2" viewBox="0 0 80 30" width="80" height="30">
        <path d="M 5,15 Q 20,5 40,15 Q 60,25 75,15" fill="none" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <svg className="hero-scribble hero-scribble-3" viewBox="0 0 40 40" width="35" height="35">
        <path d="M 5,5 L 35,35 M 35,5 L 5,35" fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
      </svg>

      {/* Crossed out word */}
      <div className="crossed-out-word" style={{ position: 'absolute', top: '8%', right: '12%' }}>
        <span style={{ fontFamily: "'Caveat', cursive", fontSize: '24px', opacity: 0.4, textDecoration: 'line-through', textDecorationThickness: '3px' }}>
          roadmap
        </span>
      </div>
      <div className="crossed-out-word" style={{ position: 'absolute', top: '15%', left: '8%' }}>
        <span style={{ fontFamily: "'Caveat', cursive", fontSize: '20px', opacity: 0.35, textDecoration: 'line-through', textDecorationThickness: '3px' }}>
          AI-powered
        </span>
      </div>

      {/* MAIN TITLE */}
      <h1 className="hero-title">
        <span className="hero-title-line">BRING BACK</span>
        <span className="hero-title-line hero-title-accent">RANDOM COINS</span>
      </h1>

      {/* Subtitle */}
      <p className="hero-subtitle">
        we used to buy coins because they looked stupid<br />
        now everyone thinks they're a genius<br />
        <span className="hero-subtitle-emphasis">this is wrong</span>
      </p>

      {/* Mascot + speech bubble cluster */}
      <div className="hero-mascot-area">
        <ScribbleArrow style={{ position: 'absolute', top: -40, right: -20, transform: 'rotate(25deg)' }} />
        <div className="hero-mascot-container">
          <DoodMascot size={300} />
          <SpeechBubble />
        </div>
        <p className="hero-mascot-label">(click me, i change)</p>
      </div>

      {/* CTA Buttons */}
      <div className="hero-buttons">
        <ScribbleButton variant="primary" onClick={onScribbleToggle}>
          {isScribbling ? '✓ STOP SCRIBBLING' : '🖍️ SCRIBBLE'}
        </ScribbleButton>
        <ScribbleButton variant="secondary" onClick={() => alert('you feel lucky. this is the way.')}>
          I FEEL LUCKY
        </ScribbleButton>
        <ScribbleButton variant="primary" onClick={() => alert('APE MODE ACTIVATED 🦍')}>
          APE RANDOMLY
        </ScribbleButton>
      </div>

      <div className="hero-buttons" style={{ marginTop: '16px' }}>
        <ScribbleButton variant="x" href="https://x.com/i/communities/2037235368282443942/" style={{ fontSize: '18px' }}>
          𝕏 COMMUNITY
        </ScribbleButton>
      </div>

      {/* Hand-drawn underline accent */}
      <svg className="hero-underline" viewBox="0 0 400 15" width="350" height="12">
        <path
          d="M 5,8 Q 50,2 100,9 Q 150,15 200,7 Q 250,0 300,10 Q 350,14 395,6"
          fill="none"
          stroke="#1a1a1a"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </section>
  );
}
